import React, {useEffect, useState} from "react";
import { colors, fonts, glyphs } from "../../Styles";
import { styled } from "styletron-react";

// #region | CheckStyles
/* eslint-disable no-unused-vars */
export enum CheckStyles {
  transparent = "transparent",
  grey = "grey",
  blue = "blue"
}
/* eslint-enable no-unused-vars */

const createCheckStyle = (checkStyle?: CheckStyles | string ) => {
  let colorStyle = ""
  let borderStyle = ""
  let borderRadius = ""
  let size = ""
  let textStyle
  let checkMarkColor: colors

  switch (checkStyle) {
    case CheckStyles.transparent:
      colorStyle = colors.transparent
      borderStyle = "2px solid "+colors.greyTertiary
      borderRadius = "5px"
      size = "22px"
      textStyle = {color: "none", ...fonts.fontSize3}
      checkMarkColor = colors.systemGreen
      break
    case CheckStyles.grey:
      colorStyle = colors.transparent
      borderStyle = "2px solid "+colors.greyLightSecondary
      borderRadius = "5px"
      size = "22px"
      textStyle = {color: colors.greyDarkPrimary, ...fonts.fontSize4}
      checkMarkColor = colors.systemGreen
      break
    case CheckStyles.blue:
      default:
      colorStyle = colors.blueDarkSecondary
      borderStyle = "none"
      borderRadius = "10px"
      size = "30px"
      textStyle = {color: colors.greyLightTertiary, ...fonts.fontSize3}
      checkMarkColor = colors.greyLightTertiary
      break
  }

  return {colorStyle, borderStyle, borderRadius, size, textStyle, checkMarkColor}
}
// #endregion

// #region | Styled Input Type Checkbox
interface StyledInputProps {
  size?: string
}

export const StyledCheckBox = styled<"input", StyledInputProps>("input", (props) => ({
  width: props.size,
  height: props.size,
  cursor: 'pointer',
  pointerEvents: 'auto',
  appearance: 'none',
  margin: "0px",
  zIndex: 3,
  position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
}));

// #endregion
interface Check_Props {
  text?: string
  isChecked?: boolean;
  disabled?:boolean;
  onChange?: (e:boolean) => void;
  checkStyle?: CheckStyles
}
/**
 * CheckBox
 * @param text - The text displayed next to the checkbox.
 * @param isChecked - Indicates whether the checkbox is checked.
 * @param disabled - Disables the checkbox if `true`.
 * @param onChange - Callback function triggered when the value changes.
 * @param checkStyle - Defines the style of the checkbox (e.g., color and size).
 * @returns A styled checkbox with optional text.
 */
export default function CheckBox({ text, onChange, disabled, isChecked, checkStyle }:Check_Props) {
  const [checked, setChecked] = useState(isChecked || false);
  const { colorStyle, borderStyle, borderRadius, size, checkMarkColor, textStyle } = createCheckStyle(checkStyle);

  useEffect(() => {
    setChecked(isChecked || false);
  }, [isChecked]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked;
    setChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  const _root = text
  ? { display: "flex", flexDirection: "row" as const, alignItems: "center", justifyContent: "start", gap: "10px"}
  : undefined

  return (
    <div style={{..._root}}> 
      <div style={{position: "relative", width: size, height: size, boxSizing: "border-box", zIndex: "1", backgroundColor: colorStyle, border: borderStyle, borderRadius: borderRadius }}>
        <StyledCheckBox
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled} 
          size={size}
        />
        {!checked 
          ? <></>
          : <span style={{ zIndex: "2", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "20px", height: "20px"}}>
              <glyphs.Check fillColor={checkMarkColor}/>
            </span>
          }
      </div>
      <p style={{...fonts.paragraph, ...textStyle, cursor: 'cursor'}}>{text}</p>
    </div>
  );
}